import {
  createContext,
  type PropsWithChildren,
  type RefObject,
  useContext,
  useMemo,
  useRef,
  useState
} from 'react';

type WidgetContextType = {
  widgetRef: RefObject<HTMLDivElement | null>;
  widgetWidth: number;
  setWidgetWidth: (width: number) => void;
};

export const WidgetContext = createContext<WidgetContextType>({
  widgetRef: { current: null },
  widgetWidth: 0,
  setWidgetWidth: () => {}
});

export const WidgetProvider = ({ children }: PropsWithChildren) => {
  const widgetRef = useRef<HTMLDivElement | null>(null);
  const [widgetWidth, setWidgetWidth] = useState(0);

  const value = useMemo(
    () => ({
      widgetRef,
      widgetWidth,
      setWidgetWidth
    }),
    [widgetWidth]
  );

  return (
    <WidgetContext.Provider value={value}>{children}</WidgetContext.Provider>
  );
};

export function useWidgetContext() {
  const context = useContext(WidgetContext);
  if (!context) {
    throw new Error('useWidgetContext must be used within WidgetProvider');
  }

  return context;
}
